<template>
  <div class="container fluid">
    <div class="mb-2">
      <h1>ประเมินความพึงพอใจแอดมิน</h1>
      <v-layout row wrap class="ma-0 pa-0" justify-space-between>
        <v-flex>
          <v-chip
            v-if="filter.agent"
            color="info"
            style="color: white"
            close
            @input="clearSearchSomeKey('agent')"
            >agent : {{ filter.agent }}</v-chip
          >
          <v-chip
            v-if="filter.ticket_id"
            color="info"
            style="color: white"
            close
            @input="clearSearchSomeKey('ticket_id')"
            >Ticket no. : {{ filter.ticket_id }}</v-chip
          >
        </v-flex>
        <v-flex>
          <v-layout row nowrap justify-end>
            <v-btn color="primary" outline @click="showSearch = true"
              ><v-icon small>&nbsp;search&nbsp;</v-icon> {{ $t('Search') }}</v-btn
            >
            <exportxlsx :promised-value="getXlsxData"></exportxlsx>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-data-table
        :headers="headers"
        :items="rawData"
        class="elevation-1"
        :loading="loading"
        hide-actions
      >
        <template #items="props">
          <td>{{ props.item.agent }}</td>
          <td>
            {{
              props.item.last_ticket_survey && props.item.last_ticket_survey.submit_timestamp
                ? dayjs(props.item.last_ticket_survey.submit_timestamp).format('DD/MM/YYYY HH:mm')
                : '-'
            }}
          </td>
          <td>
            {{
              props.item.last_ticket_survey && props.item.last_ticket_survey.ticket_id
                ? props.item.last_ticket_survey.ticket_id
                : '-'
            }}
          </td>
          <td>
            {{
              props.item.last_ticket_survey &&
              props.item.last_ticket_survey.survey_data &&
              props.item.last_ticket_survey.survey_data[1]
                ? props.item.last_ticket_survey.survey_data[1]
                : '-'
            }}
          </td>
          <td>
            {{
              props.item.last_ticket_survey &&
              props.item.last_ticket_survey.survey_data &&
              props.item.last_ticket_survey.survey_data[2]
                ? props.item.last_ticket_survey.survey_data[2]
                : '-'
            }}
          </td>
          <td>
            {{
              props.item.last_ticket_survey &&
              props.item.last_ticket_survey.survey_data &&
              props.item.last_ticket_survey.survey_data[3]
                ? props.item.last_ticket_survey.survey_data[3]
                : '-'
            }}
          </td>
          <td>
            <v-btn flat icon small color="primary" @click="handleShowInAgent(props.item.agent)">
              <em class="fas fa-list" />
            </v-btn>
          </td>
        </template>
      </v-data-table>
      <v-layout row wrap justify-end class="mt-3">
        <v-pagination
          v-model="pageNumber"
          :length="pageCount"
          @input="handleChangePage"
        ></v-pagination>
      </v-layout>
    </div>
    <v-dialog
      v-model="showSearch"
      scrollable
      persistent
      :overlay="false"
      max-width="500px"
      transition="dialog-transition"
    >
      <v-card>
        <div class="text-xs-right">
          <v-btn fab small flat @click="showSearch = false">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <v-layout wrap class="form-control">
            <v-flex xs12>
              <div class="caption">Agent</div>
              <input v-model="filter.agent" type="text" placeholder="Agent" />
            </v-flex>
            <v-flex xs12>
              <div class="caption">Ticket no.</div>
              <input v-model="filter.ticket_id" type="text" placeholder="Ticket no." />
            </v-flex>
          </v-layout>
          <v-layout row wrap justify-center>
            <v-btn outline color="grey" @click="handleClearSearch">{{ $t('Clear Search') }}</v-btn>
            <v-btn depressed color="primary" @click="handleSearch">
              <em class="fas fa-search mr-1" />
              {{ $t('Search') }}
            </v-btn>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-if="showDetailAgent && showDetailAgentData"
      v-model="showDetailAgent"
      scrollable
      persistent
      :overlay="false"
      transition="dialog-transition"
    >
      <v-card>
        <div class="text-xs-right">
          <v-btn fab small flat @click="showDetailAgent = false">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <AdminSatisfactionSurveyByAgent :agent-id="showDetailAgentData" />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import exportxlsx from '@/components/elements/exportxlsx.vue'
import ticketApi from '../../../../../api/ticket'
import { handleApiError } from '../../../../../api/util'
import AdminSatisfactionSurveyByAgent from './AdminSatisfactionSurveyByAgent.vue'
import dayjs from 'dayjs'

const baseFilter = {
  agent: '',
  ticket_id: ''
}

export default {
  components: { exportxlsx, AdminSatisfactionSurveyByAgent },
  data() {
    return {
      pageNumber: 1,
      rowPerPage: 10,
      total: 0,
      channelFilter: 'all',
      rawData: [],
      filter: { ...baseFilter },
      headers: [
        { text: 'Agent', value: 'agent', sortable: false },
        { text: 'เวลาประเมิน', value: 'submit_timestamp', sortable: false },
        { text: 'Ticket no.', value: 'ticket_id', sortable: false },
        { text: 'คำถามที่ 1', sortable: false },
        { text: 'คำถามที่ 2', sortable: false },
        { text: 'คำถามที่ 3', sortable: false },
        { text: '', sortable: false }
      ],
      showSearch: false,
      isExport: false,
      loading: false,
      showDetailAgent: false,
      showDetailAgentData: null
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    dayjs() {
      return dayjs
    },
    pageCount() {
      return Math.ceil(this.total / this.rowPerPage)
    },
    offset() {
      return this.pageNumber * this.rowPerPage - this.rowPerPage
    }
  },
  mounted() {
    this.getSatisfactionSurvey()
  },
  methods: {
    clearSearchSomeKey(key) {
      this.filter[key] = ''
      this.getSatisfactionSurvey()
    },
    handleClearSearch() {
      this.filter = { ...baseFilter }
      this.pageNumber = 1
      this.showSearch = false
      this.getSatisfactionSurvey()
    },
    handleSearch() {
      this.showSearch = false
      this.getSatisfactionSurvey()
    },
    async getSatisfactionSurvey() {
      try {
        this.loading = true
        await this.fetchSatisfactionSurvey()
      } catch (error) {
        handleApiError(error)
      } finally {
        this.loading = false
      }
    },
    async handleChangePage(page) {
      this.pageNumber = page
      this.getSatisfactionSurvey()
    },
    handleShowInAgent(adminId) {
      this.showDetailAgent = true
      this.showDetailAgentData = adminId
    },
    setSatisfactionSurveyData(returnData) {
      const total = returnData.total
      const data = returnData.data
      this.total = total
      this.rawData = data
    },
    async fetchSatisfactionSurvey(setData = true, overWriteLimit = null, overWriteOffset = null) {
      try {
        const params = {
          page_id: this.selectedBot.pageid,
          limit: overWriteLimit ? overWriteLimit : this.rowPerPage,
          offset: overWriteOffset ? overWriteOffset : this.offset,
          agent: this.filter.agent,
          ticket_id: this.filter.ticket_id
        }
        const responseData = await ticketApi.getSatisfactionSurvey(params)
        setData && this.setSatisfactionSurveyData(responseData.data)
        return responseData.data
      } catch (error) {
        handleApiError(error)
      }
    },
    getXlsxData() {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve) => {
        this.isExport = true
        const responseData = await this.fetchSatisfactionSurvey(false, 99999, 0)
        resolve(
          responseData.data.map((data) => {
            return {
              agent: data.agent,
              เวลาประเมิน: '-',
              'Ticket no.':
                data.last_ticket_survey && data.last_ticket_survey.ticket_id
                  ? data.last_ticket_survey.ticket_id
                  : '-',
              'คำถามที่ 1':
                data.last_ticket_survey &&
                data.last_ticket_survey.survey_data &&
                data.last_ticket_survey.survey_data[1]
                  ? data.last_ticket_survey.survey_data[1]
                  : '-',
              'คำถามที่ 2':
                data.last_ticket_survey &&
                data.last_ticket_survey.survey_data &&
                data.last_ticket_survey.survey_data[2]
                  ? data.last_ticket_survey.survey_data[2]
                  : '-',
              'คำถามที่ 3':
                data.last_ticket_survey &&
                data.last_ticket_survey.survey_data &&
                data.last_ticket_survey.survey_data[3]
                  ? data.last_ticket_survey.survey_data[3]
                  : '-'
            }
          })
        )
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/customize/juzmatch/AdminSatisfactionSurvey.vue